import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {MatDialog} from '@angular/material/dialog';
import {Router} from '@angular/router';
import {AplicacionService} from 'src/app/_module/procesadora/aplicacion-datos/aplicacion/aplicacion.service';
import {AplicacionVersionService} from 'src/app/_module/procesadora/aplicacion-datos/aplicacion-version/aplicacion-version.service';
import {NotificacionesService} from 'src/app/_app_services/notificaciones.service';
import {Formularios} from 'src/app/_helpers/clases/formularios';
import {PageHeaderDataService} from 'src/app/shared/services/page-header-data.service';
import {PageHeaderData} from 'src/app/shared/components/forms-header/page-header-data';
import {AplicacionVersion} from 'src/app/_models/aplicacion-version';
import {Aplicacion} from 'src/app/_models/aplicacion';


/**
 * Formulario ABM de las versiones de las aplicaciones utilizadas.
 * @author Alejandro Planas
 */
@Component({
  selector: 'app-aplicacion-version-form',
  templateUrl: './aplicacion-version-form.component.html',
  //   styleUrls: ['./aplicacion-version-form.component.scss']
})
export class AplicacionVersionFormComponent extends Formularios<AplicacionVersion> implements OnInit {

  constructor(
    public router: Router,
    public dialog: MatDialog,
    private fb: FormBuilder,
    public notificacionService: NotificacionesService,
    public service: AplicacionVersionService,
    private headerDataService: PageHeaderDataService,
    public aplicacionService: AplicacionService
  ) {
    super(router, dialog, 'procesadora/aplicacion_version', service, notificacionService);

  }

  ngOnInit(): void {
    super.ngOnInit();
    super.formularioAbs = this.construirFormGroup();
    if (super.editar) {
      super.formularioAbs.setValue(this.service.getItem());
    } else {
      this.service.restartItem();
    }
    this.headerDataService.setHeaderData(new PageHeaderData('Version de Aplicacion', this.rutaPadre, true));
  }

  construirFormGroup(): FormGroup {
    return this.fb.group({
      id: [null],
      version: [{value: '', disabled: super.dis}, Validators.required],
      descripcion: [{value: '', disabled: super.dis}],
      activo: [{value: true, disabled: super.dis}],
      aplicacion: new Aplicacion()

    });
  }

  getErrorMessage(cName: string): string {
    if (this.formularioAbs.controls[cName].hasError('required')) {
      return 'Campo requerido';
    }
  }


}
